'use client';
import React, { useEffect, useState } from 'react';
import Image from 'next/image';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const handleScroll = (id: string) => {
    setMenuOpen(false);
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <>
      <header data-component-id="src/components/Header.tsx:33:6" data-component-path="src/components/Header.tsx" data-component-line="33" data-component-end-line="103" data-component-file="Header.tsx" data-component-name="header" data-component-content="%7B%22elementName%22%3A%22header%22%7D"
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
          scrolled
            ? 'bg-white/95 backdrop-blur-md shadow-soft border-b border-black/5 py-3'
            : 'bg-transparent py-5'
        }`}
      >
        <div data-component-id="src/components/Header.tsx:40:8" data-component-path="src/components/Header.tsx" data-component-line="40" data-component-end-line="102" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-5%20sm%3Apx-8%20flex%20items-center%20justify-between%22%7D" className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between">
          
          {/* Logo Only */}
          <div data-component-id="src/components/Header.tsx:43:10" data-component-path="src/components/Header.tsx" data-component-line="43" data-component-end-line="55" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%22%7D" className="flex items-center">
            <Image data-component-id="src/components/Header.tsx:44:12" data-component-path="src/components/Header.tsx" data-component-line="44" data-component-end-line="54" data-component-file="Header.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fassets%2Fimages%2Fmpes-logo.png%22%2C%22alt%22%3A%22School%20Logo%22%2C%22className%22%3A%22h-9%20w-auto%20cursor-pointer%20object-contain%22%7D"
  src="/assets/images/mpes-logo.png"
  alt="School Logo"
  width={0}
  height={0}
  sizes="100vw"
  className="h-9 w-auto cursor-pointer object-contain"
  onClick={() =>
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
/>
          </div>

          {/* Desktop Nav */}
          <nav data-component-id="src/components/Header.tsx:58:10" data-component-path="src/components/Header.tsx" data-component-line="58" data-component-end-line="73" data-component-file="Header.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%2C%22className%22%3A%22hidden%20md%3Aflex%20items-center%20gap-8%20text-%5B13px%5D%20font-semibold%20text-ink%2F60%22%7D" className="hidden md:flex items-center gap-8 text-[13px] font-semibold text-ink/60">
            {[
              { label: 'Why Us', id: 'why-us' },
              { label: 'Programs', id: 'programs' },
              { label: 'Facilities', id: 'facilities' },
              { label: 'Testimonials', id: 'testimonials' },
            ].map((item) => (
              <button data-component-id="src/components/Header.tsx:65:14" data-component-path="src/components/Header.tsx" data-component-line="65" data-component-end-line="71" data-component-file="Header.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22hover%3Atext-ink%20transition-colors%20cursor-pointer%22%7D"
                key={item.id}
                onClick={() => handleScroll(item.id)}
                className="hover:text-ink transition-colors cursor-pointer"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* Right Actions */}
          <div data-component-id="src/components/Header.tsx:76:10" data-component-path="src/components/Header.tsx" data-component-line="76" data-component-end-line="101" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-3%22%7D" className="flex items-center gap-3">
            <a data-component-id="src/components/Header.tsx:77:12" data-component-path="src/components/Header.tsx" data-component-line="77" data-component-end-line="84" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22https%3A%2F%2Fwa.me%2F917795297878%22%2C%22className%22%3A%22hidden%20sm%3Ainline-flex%20items-center%20gap-2%20bg-peach-accent%20text-white%20px-5%20py-2.5%20rounded-pill%20text-%5B13px%5D%20font-bold%20hover%3Abg-opacity-90%20transition-all%20mag-btn%22%2C%22textContent%22%3A%22WhatsApp%22%7D"
              href="https://wa.me/917795297878"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:inline-flex items-center gap-2 bg-peach-accent text-white px-5 py-2.5 rounded-pill text-[13px] font-bold hover:bg-opacity-90 transition-all mag-btn"
            >
              WhatsApp
            </a>

            <button data-component-id="src/components/Header.tsx:86:12" data-component-path="src/components/Header.tsx" data-component-line="86" data-component-end-line="100" data-component-file="Header.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22md%3Ahidden%20p-2%20rounded-lg%20hover%3Abg-black%2F5%20transition-colors%22%7D"
              onClick={() => setMenuOpen(!menuOpen)}
              className="md:hidden p-2 rounded-lg hover:bg-black/5 transition-colors"
              aria-label="Toggle menu"
            >
              {menuOpen ? (
                <svg data-component-id="src/components/Header.tsx:92:16" data-component-path="src/components/Header.tsx" data-component-line="92" data-component-end-line="94" data-component-file="Header.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path data-component-id="src/components/Header.tsx:93:18" data-component-path="src/components/Header.tsx" data-component-line="93" data-component-end-line="93" data-component-file="Header.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M18 6L6 18M6 6l12 12" />
                </svg>
              ) : (
                <svg data-component-id="src/components/Header.tsx:96:16" data-component-path="src/components/Header.tsx" data-component-line="96" data-component-end-line="98" data-component-file="Header.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%7D" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path data-component-id="src/components/Header.tsx:97:18" data-component-path="src/components/Header.tsx" data-component-line="97" data-component-end-line="97" data-component-file="Header.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M3 12h18M3 6h18M3 18h18" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile menu */}
      {menuOpen && (
        <div data-component-id="src/components/Header.tsx:107:8" data-component-path="src/components/Header.tsx" data-component-line="107" data-component-end-line="132" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20inset-0%20z-40%20bg-white%2F98%20backdrop-blur-xl%20flex%20flex-col%20items-center%20justify-center%20gap-8%20md%3Ahidden%22%7D" className="fixed inset-0 z-40 bg-white/98 backdrop-blur-xl flex flex-col items-center justify-center gap-8 md:hidden">
          {[
            { label: 'Why Us', id: 'why-us' },
            { label: 'Programs', id: 'programs' },
            { label: 'Facilities', id: 'facilities' },
            { label: 'Testimonials', id: 'testimonials' },
            { label: 'Book a Tour', id: 'form' },
          ].map((item) => (
            <button data-component-id="src/components/Header.tsx:115:12" data-component-path="src/components/Header.tsx" data-component-line="115" data-component-end-line="121" data-component-file="Header.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22font-display%20text-3xl%20font-semibold%20text-ink%20hover%3Atext-peach-accent%20transition-colors%22%7D"
              key={item.id}
              onClick={() => handleScroll(item.id)}
              className="font-display text-3xl font-semibold text-ink hover:text-peach-accent transition-colors"
            >
              {item.label}
            </button>
          ))}

          <a data-component-id="src/components/Header.tsx:124:10" data-component-path="src/components/Header.tsx" data-component-line="124" data-component-end-line="131" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22https%3A%2F%2Fwa.me%2F917795297878%22%2C%22className%22%3A%22mt-4%20flex%20items-center%20gap-2%20bg-peach-accent%20text-white%20px-8%20py-4%20rounded-pill%20text-base%20font-bold%22%2C%22textContent%22%3A%22Chat%20on%20WhatsApp%22%7D"
            href="https://wa.me/917795297878"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 flex items-center gap-2 bg-peach-accent text-white px-8 py-4 rounded-pill text-base font-bold"
          >
            Chat on WhatsApp
          </a>
        </div>
      )}
    </>
  );
}